import { Note, YouthKid } from "common";
import { useMemo } from "react";

export const useNoteYouthKid = (
  note: Note
): Omit<YouthKid, "properties"> | null => {
  return useMemo(() => note.youthKids[0] ?? null, [note.youthKids]);
};
